import { actionTypes, SetUtmCampaign } from "./Actions";

const setUtmCampaign: SetUtmCampaign = (campaign: string) => ({
  campaign,
  type: actionTypes.SET_UTM_CAMPAIGN
});

export default setUtmCampaign;
